
















import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({ name: 'FmlNavBar' })
export default class FmlNavBar extends Vue {
  @Prop({ type: String, default: '' }) title!: String;
  @Prop({ type: String, default: '' }) leftText?: String;
  @Prop({ type: String, default: '' }) rightText?: String;
  @Prop({ type: Boolean, default: true }) leftArrow!: Boolean;
  @Prop({ type: Boolean, default: false }) backApp?: Boolean;

  //左侧单击
  onClickLeft() {
    // this.backApp && wx.miniProgram.navigateBack({delta:1});
    //   // wx.miniProgram.navigateTo({ url: this.$store.state.user.ReturnUrl });
      
    // !this.backApp && this.$router.back();
    this.$router.back();
  }

  //右侧单击
  onClickRight() {}
}
